const disableDefaultBehaviorForEmptyLinks = require("../run/links/disableDefaultBehaviorForEmptyLinks");

const initRoiCalculator = require("../run/./roiCalculator/initRoiCalculator");
const initWhitepaper2024 = require("../run/whitepaper2024/initWhitepaper2024");
const initUniformFormFieldsForAllForms = require("../run/uniformFormFields/initUniformFormFieldsForAllForms");
const initPrivacyPolicyCheckboxes = require("../run/privacyPolicyCheckbox/initPrivacyPolicyCheckboxes");
const whenPrivacyPolicyCheckboxUpdates = require("./whenPrivacyPolicyCheckboxUpdates");
const initCountrySelects = require("../run/countrySelect/initCountrySelects");
const initCompanyEmailInputs = require("../run/companyEmailInput/initCompanyEmailInputs");
const whenFirstRoiGateFormCountryFieldUpdate = require("./roiCalculator/whenFirstRoiGateFormCountryFieldUpdate");
const whenFirstRoiGateFormFirstNameFieldUpdate = require("./roiCalculator/whenFirstRoiGateFormFirstNameFieldUpdate");
const whenFirstRoiGateFormLastNameFieldUpdate = require("./roiCalculator/whenFirstRoiGateFormLastNameFieldUpdate");
const whenFirstRoiGateFormCompanyFieldUpdate = require("./roiCalculator/whenFirstRoiGateFormCompanyFieldUpdate");
const whenRoiGateFormSubmits = require("./roiCalculator/whenRoiGateFormSubmits");
const whenRoiCalculatorFormUpdatedEvent = require("./roiCalculator/whenRoiCalculatorFormUpdatedEvent");
const whenRoiCalculatorFormSubmittedEvent = require("./roiCalculator/whenRoiCalculatorFormSubmittedEvent");
const whenRoiCalculatorOutputUrlEvent = require("./roiCalculator/whenRoiCalculatorOutputUrlEvent");
const whenRoiCalculatorOutputFailedEvent = require("./roiCalculator/whenRoiCalculatorOutputFailedEvent");
const whenRoiCalculatorTopDownloadPdfButtonClicked = require("./roiCalculator/whenRoiCalculatorTopDownloadPdfButtonClicked");
const whenRoiCalculatorBottomDownloadPdfButtonClicked = require("./roiCalculator/whenRoiCalculatorBottomDownloadPdfButtonClicked");
const whenWhitepaper2024FormSubmits = require("./whitepaper2024/whenWhitepaper2024FormSubmits");
const whenWhitepaper2024ReturningUserShowContentClicked = require("./whitepaper2024/whenWhitepaper2024ReturningUserShowContentClicked");
const initReturningUser = require("../run/returningUser/initReturningUser");
const whenWhitepaper2024NotYouButtonClicked = require("./whitepaper2024/whenWhitepaper2024NotYouButtonClicked");
const whenRoiCalculatorReturningUserCtaClicked = require("./whenRoiCalculatorReturningUserCtaClicked");
const whenRoiCalculatorNotYouClicked = require("./whenRoiCalculatorNotYouClicked");
const copySelectOptionsFromMarketoFormIntoNativeField = require("../run/marketo/copySelectOptionsFromMarketoFormIntoNativeField");
const copyCountryOptionsFromMarketoFormIntoNativeFormCountrySelect = require("../run/marketo/copyCountryOptionsFromMarketoFormIntoNativeFormCountrySelect");
const PreferenceCenter_initAll = require("../run/emailPreferenceCenter/PreferenceCenter_initAll");
const customerStoriesSidebarScrollListener = require("../run/customer-stories/customerStoriesSidebarScrollListener");
const When_CountrySelect_changes = require("../When_CountrySelect_changes");
const PageProduct = require("../PageProduct");

/**
 * @return {void}
 */
function initializeDynamicMarketoValuesForAllFormsOnThePage() {
    window.document.querySelectorAll('[name="formVid"]').forEach(formVidInput => {
        if (formVidInput instanceof HTMLInputElement) {
            const marketoId = formVidInput.value;

            const form = formVidInput.closest('form');

            const countryField = form.querySelector('[name="Country"]');
            const companySizeField = form.querySelector('[name="Company_Size_Range__c"]');
            const primaryUseCaseField = form.querySelector('[name="Primary_Use_Case__c"]');
            const emailSendsPerMonthField = form.querySelector('[name="Email_Sends_per_Month_Range__c"]');
            const referralContactPreferenceField = form.querySelector('[name="referralContactPreference"]');
            const activateCityField = form.querySelector('[name="activateCity"]');

            if (countryField || companySizeField || primaryUseCaseField || emailSendsPerMonthField) {
                const munchkinIdField = form.querySelector('[name="munchkinId"]')
                const munchkinId = munchkinIdField ? munchkinIdField.value : "";

                const formContainer = window.document.createElement("div");
                formContainer.style.display = "none";
                formContainer.innerHTML = `<form id="mktoForm_${marketoId}"></form>`;
                window.document.body.append(formContainer);

                window.MktoForms2.loadForm(
                    'https://go.iterable.com',
                    munchkinId,
                    marketoId,
                    function (form) {
                        document.querySelectorAll('#mktoStyleLoaded').forEach(mktoStyleLoaded => {
                            mktoStyleLoaded.remove();
                        });

                        if (countryField) {
                            copyCountryOptionsFromMarketoFormIntoNativeFormCountrySelect(form, countryField);
                        }

                        const fields = [
                            {name: 'Company_Size_Range__c', field: companySizeField},
                            {name: 'Primary_Use_Case__c', field: primaryUseCaseField},
                            {name: 'Email_Sends_per_Month_Range__c', field: emailSendsPerMonthField},
                            {name: 'referralContactPreference', field: referralContactPreferenceField},
                            {name: 'activateCity', field: activateCityField},
                        ].filter(x => x.field);

                        for (let field of fields) {
                            copySelectOptionsFromMarketoFormIntoNativeField(form, field.field);
                        }

                        formContainer.remove();
                    }
                );
            }
        }
    });
}

/**
 * @returns {Promise<void>}
 */
module.exports = async function whenDocumentReady() {
    initUniformFormFieldsForAllForms();

    initPrivacyPolicyCheckboxes((checkbox) => whenPrivacyPolicyCheckboxUpdates(checkbox));

    try {
        await initializeDynamicMarketoValuesForAllFormsOnThePage();
        await initCountrySelects(countrySelect => {
            When_CountrySelect_changes(countrySelect);
        });
    } catch (e) {
        console.error(e);
    }

    initCompanyEmailInputs();

    initReturningUser();

    try {
        /**
         * @type {RoiCalculatorTimeout}
         */
        const roiCalculatorLoadingTimeout = {
            timeoutId: -1,
        };

        /**
         * @type {InitRoiCalculatorArgs}
         */
        const initRoiCalculatorArgs = {
            onFirstRoiGateFormCountryFieldUpdate: () => whenFirstRoiGateFormCountryFieldUpdate(),
            onFirstRoiGateFormFirstNameFieldUpdate: () => whenFirstRoiGateFormFirstNameFieldUpdate(),
            onFirstRoiGateFormLastNameFieldUpdate: () => whenFirstRoiGateFormLastNameFieldUpdate(),
            onFirstRoiGateFormCompanyFieldUpdate: () => whenFirstRoiGateFormCompanyFieldUpdate(),
            onRoiGateFormSubmit: (form) => whenRoiGateFormSubmits(form),
            onRoiCalculatorFormUpdatedEvent: (calculatorData) => whenRoiCalculatorFormUpdatedEvent(calculatorData),
            onRoiCalculatorFormSubmittedEvent: (roiCalculatorDocument, calculatorData) => whenRoiCalculatorFormSubmittedEvent(
                roiCalculatorDocument,
                calculatorData,
                roiCalculatorLoadingTimeout
            ),
            onRoiCalculatorOutputUrlEvent: (outputUrl) => whenRoiCalculatorOutputUrlEvent(
                outputUrl,
                roiCalculatorLoadingTimeout
            ),
            onRoiCalculatorOutputFailedEvent: () => whenRoiCalculatorOutputFailedEvent(roiCalculatorLoadingTimeout),
            onRoiCalculatorTopDownloadPdfButtonClicked: () => whenRoiCalculatorTopDownloadPdfButtonClicked(),
            onRoiCalculatorBottomDownloadPdfButtonClicked: () => whenRoiCalculatorBottomDownloadPdfButtonClicked(),
            onReturningUserNotYouClick: () => whenRoiCalculatorNotYouClicked(),
            onReturningUserCtaClick: () => whenRoiCalculatorReturningUserCtaClicked(),
        }

        void initRoiCalculator(initRoiCalculatorArgs);
    } catch (e) {
        console.error(e);
    }

    try {
        void initWhitepaper2024(
            (form) => whenWhitepaper2024FormSubmits(form),
            () => whenWhitepaper2024ReturningUserShowContentClicked(),
            () => whenWhitepaper2024NotYouButtonClicked(),
        );
    } catch (e) {
        console.error(e);
    }

    disableDefaultBehaviorForEmptyLinks();

    PreferenceCenter_initAll();

    customerStoriesSidebarScrollListener();

    PageProduct.init();
};